import * as Toast from '@radix-ui/react-toast';
import { X } from 'lucide-react';
import clsx from 'clsx';
import { useUIStore } from '@/shared/stores/ui-store';
import styles from './AppToast.module.scss';

/**
 * Toast notification provider and renderer.
 * Reads from the global UI store toast queue.
 */
export function AppToast() {
  const toastQueue = useUIStore((s) => s.toastQueue);
  const removeToast = useUIStore((s) => s.removeToast);

  return (
    <Toast.Provider swipeDirection="right">
      {toastQueue.map((toast) => (
        <Toast.Root
          key={toast.id}
          className={clsx(styles.root, styles[toast.variant])}
          onOpenChange={(open) => {
            if (!open) removeToast(toast.id);
          }}
          duration={toast.duration ?? 4000}
        >
          <div className={styles.content}>
            {toast.title && <Toast.Title className={styles.title}>{toast.title}</Toast.Title>}
            <Toast.Description className={styles.description}>{toast.message}</Toast.Description>
          </div>
          <Toast.Close className={styles.close} aria-label="Dismiss">
            <X size={14} />
          </Toast.Close>
        </Toast.Root>
      ))}
      <Toast.Viewport className={styles.viewport} />
    </Toast.Provider>
  );
}
